import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { FileText, Download, Eye, Lock } from "lucide-react";

// Sign-in-protected landing page for durable links to private files.
export default function SharedFile() {
  const { shareId } = useParams();
  const [meta, setMeta] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/files/shared/${shareId}`).then((r) => setMeta(r.data)).catch((e) => setErr(apiError(e))); }, [shareId]);
  const open = async (download) => {
    try {
      const r = await api.get(`/files/shared/${shareId}/content`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      if (download) { const a = document.createElement("a"); a.href = url; a.download = meta.filename || "file"; a.click(); }
      else window.open(url, "_blank", "noopener");
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (e) { setErr(apiError(e)); }
  };
  return (
    <div className="max-w-xl mx-auto mt-10" data-testid="shared-file-page">
      <div className="rounded-xl border border-slate-200 bg-white p-6 space-y-4">
        {err ? <div data-testid="shared-file-error"><p className="font-semibold text-slate-900 flex items-center gap-2"><Lock className="w-4 h-4" />File not available</p><p className="text-sm text-slate-600 mt-1">{err}</p></div>
          : !meta ? <p className="text-sm text-slate-400">Checking access…</p>
          : <>
            <div className="flex items-start gap-3"><FileText className="w-8 h-8 text-[#006090] shrink-0" />
              <div className="min-w-0"><p className="font-semibold text-slate-900" data-testid="shared-file-title">{meta.title || meta.filename}</p>
                <p className="text-xs text-slate-500">{meta.filename}</p></div></div>
            <div className="flex gap-2">
              <Button onClick={() => open(false)} className="bg-brand hover:bg-brand-strong" data-testid="shared-file-view"><Eye className="w-4 h-4 mr-1.5" />Open</Button>
              <Button variant="outline" onClick={() => open(true)} data-testid="shared-file-download"><Download className="w-4 h-4 mr-1.5" />Download</Button>
            </div>
          </>}
      </div>
    </div>
  );
}
